import httpClient from "@/apis/base/axios-httpclient";
import api from "@/apis/LayoutTemplateAPI";
import Crud from "./crud-base";
var crud = new Crud("LayoutTemplate", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "LayoutTemplateID",
      name: "LayoutTemplateName",
    },
  },
  /**
   * Mẫu áp dụng
   */
  apply: {},
};
const getters = {
  ...crud.getters,
  apply: function (state) {
    return state.aplly;
  },
};
const actions = {
  ...crud.actions,
  async loadApply(context, payload) {
    context.commit("updateLoading", true);

    let url = [api.getAPIUrl(), "apply"];
    if (payload) {
      url.push(payload);
    }

    let request = {
      url: url.join("/"),
    };

    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);

    if (res) {
      context.commit("updateApply", {
        tag: payload,
        layout: res,
      });
    }

    return res;
  },

  async loadApplyDefault(context, payload) {
    context.commit("updateLoading", true);

    let url = [api.getAPIUrl(), "applyDefault"];
    if (payload) {
      url.push(payload);
    }

    let request = {
      url: url.join("/"),
    };

    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);

    if (res) {
      // context.commit("updateApply", {
      //    tag: payload,
      //    layout: res
      // });
    }

    return res;
  },

  /**
   * Lưu layout của danh sách
   * @param {*} layout dòng dữ liệu có cấu trúc như trong db
   * @param {*} method phương thức gửi dữ liệu
   */
  async updateLayout(context, layout) {
    context.commit("updateLoading", true);
    let request = {
      url: [api.getAPIUrl(), "customLayout"].join("/"), //role/users/1
      data: layout,
    };
    let res = await httpClient.postAsync(request);
    context.commit("updateLoading", false);

    context.commit("updateApply", {
      tag: layout.LayoutTag,
      layout: layout,
    });
    return res;
  },
};
const mutations = {
  ...crud.mutations,
  updateApply(state, res) {
    if (res.tag && res.layout) {
      state.apply[res.tag] = res.layout;
    }
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
